import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import "./styles/base.css";
import "./styles/tablet.css";
import "./styles/desktop.css";
import "./styles/mobile.css";
import "./styles/mobile-small.css";
import "./styles/cart.css";
import "./styles/product.css";
import "./styles/header.css";
import "./styles/search.css";
import "./styles/browse.css";
import "./styles/admin.css";
import "./styles/brand.css";
import App from "./App";
import { CartProvider } from "./context/CartContext";
import { loadPublishedInventory } from "./data/catalog";

const root = ReactDOM.createRoot(document.getElementById("root"));
if (process.env.REACT_APP_INVENTORY_SOURCE === "facebook") {
  root.render(<p role="status" style={{ padding: 32 }}>Loading the latest Facebook listings…</p>);
}
loadPublishedInventory().then(error => {
window.inventoryLoadError = error;
root.render(
  <React.StrictMode>
    <HashRouter>
      <CartProvider>
        <App />
      </CartProvider>
    </HashRouter>
  </React.StrictMode>,
);
});
